/**
 * ChallengePageV2 — redesigned Challenges list shell, port of the
 * prototype's `.screen-challenges` page-head (cms-redesign-mockup.html
 * ~line 8060–8081).
 *
 * The in-app tab description (general_settings.challenge_intro_text) is
 * edited inline via InAppDescriptionPanel under the header (per CMS
 * feedback, Monday #12171251310 — it used to hide behind an "Update
 * description" modal). The underlying actions (`fetchChallengeIntro` /
 * `updateChallengeIntro`) already exist for the v1 page and write to
 * PUT /general-info/challenge_intro_text — we reuse them as-is.
 *
 * Header action: "+ New Challenge" → coral primary, /challenges/add
 *
 * Body is ChallengesTableV2 which hosts its own status filter
 * SegmentedControl so the PageHeader stays focused on title + actions.
 */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ChallengesTableV2 from '../../ChallengeTable/v2/ChallengesTableV2';
import {
  fetchChallengeIntro,
  updateChallengeIntro,
} from '../../../actions/challengeActions';
import { PageHeader, Button, InAppDescriptionPanel } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function ChallengePageV2() {
  const dispatch = useDispatch();
  const intro = useSelector(
    (s) => s.general_data?.general_data?.challenge_intro_text || '',
  );

  useEffect(() => {
    dispatch(fetchChallengeIntro());
  }, [dispatch]);

  // Count chip — derived from the same reducer slice the table reads.
  const total = useSelector((s) => {
    const map = s.challenges.challenges;
    if (!map) return undefined;
    return Object.keys(map).length;
  });
  const totalLabel = total != null ? `${total.toLocaleString()} items` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Library"
        title="Challenges"
        total={totalLabel}
        actions={
          <Link to="/challenges/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>
              New Challenge
            </Button>
          </Link>
        }
      />
      <InAppDescriptionPanel
        tabName="Challenges"
        value={intro}
        onSave={(value) => dispatch(updateChallengeIntro(value))}
      />
      <ChallengesTableV2 />
    </div>
  );
}
